import {Table} from "antd";
import React from "react";
import companyColumns from "./companyColumns";
import {useController} from "./CompanyDatatable.controller";

const CompanyDatatable = ({ data, loading, primaryColor, onEditClick, onDeleteClick, onLicencesClick,
                              toggleCompanyDetails, companyToShowDetailsFor, companyDetailsVisible, onRemoveProductFromCompany }) => {

    const { filterCompanies, filteredCompanies } = useController();

    const updateFiltersMap = (key, type, value) => {
        filterCompanies({key, value, type});
    };

    const columns = companyColumns({primaryColor, onEditClick, onDeleteClick, onLicencesClick, toggleCompanyDetails, companyToShowDetailsFor, companyDetailsVisible, onRemoveProductFromCompany, updateFiltersMap});

    return <Table rowKey="id"
                  loading={loading}
                  // bordered
                  className="main-table"
                  scroll={{ y: window.innerHeight - 280, scrollToFirstRowOnChange: true }} // TODO check how to fix scrolling
                  size="small"
                  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                  pagination={{ pageSizeOptions: ['10', '20', '50'], showSizeChanger: true }}
                  onRow={(record, rowIndex) => {
                      return {
                          onClick: event => { }, // click row
                          onDoubleClick: event => { }, // double click row
                          onContextMenu: event => { }, // right button click row
                          onMouseEnter: event => { }, // mouse enter row
                          onMouseLeave: event => { }, // mouse leave row
                      };
                  }}
                  columns={columns}
                  dataSource={filteredCompanies}/>
};

export default CompanyDatatable;